import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import useAuth from '../../hook/useAuth';
import useConfirm from '../../hook/useConfirm';
import { post_LeadershipGroup } from '../../services/LeadershipGroup';
import useGroup from '../../hook/useGroup';
import Cookies from 'js-cookie';

const AddLeadershipGroup = () => {
     const token = Cookies.get("token-my-cdir");
    const navigate = useNavigate();
    const { auth }: any = useAuth();
    const { selectedGroupId }: any = useGroup();
    const { setConfirmPopup, setData: setConfirmData }: any = useConfirm();
    const [leadershipGroupData, setLeadershipGroupData] = useState<any>({
        groupId: 0,
        name: "",
        order: 0
    });
    const [isProcessing, setIsProcessing] = useState<boolean>(false);

    const closeModal = () => navigate(-1);

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (!isProcessing) {
            setIsProcessing(true);

            post_LeadershipGroup({
                ...leadershipGroupData,
                groupId: selectedGroupId
            }, auth?.id, token!.toString())
                .then(() => {
                    setIsProcessing(false);
                    navigate(-1);
                })
                .catch(error => {
                    setIsProcessing(false);
                    console.error(error);
                    setConfirmData({
                        title: "Warning",
                        summary: error?.response?.data,
                        confirmBtn: "Ok",
                        isCancelBtn: true,
                        isConfirm: (cb: any) => {
                            cb();
                        }
                    });
                    setConfirmPopup(true);
                });
        }
    }

    return (
        <div className="w-full">
            <div className="my-2">
                <div className="py-8 px-6 relative bg-white">
                    <h2 className="text-xl text-secondary font-bold">Add Leadership Team</h2>
                    <form onSubmit={handleSubmit} className="mt-8 grid xm:grid-cols-2 gap-6 text-secondary">   
                        <div>
                            <label className="font-semibold text-sm">Name</label>
                            <input type='text' placeholder='Enter Name'
                                className="w-full rounded py-2.5 px-4 mt-2 border-2 text-sm text-black outline-secondary"
                                value={leadershipGroupData?.name}
                                onChange={(e) => setLeadershipGroupData({ ...leadershipGroupData, name: e.target.value })}
                                required
                            />
                        </div>

                        <div>
                            <label className="font-semibold text-sm">Order</label>
                            <input type='number' placeholder="Enter Order"
                                className="w-full rounded py-2.5 px-4 border-2 mt-2 text-sm text-black outline-secondary"
                                value={leadershipGroupData.order}
                                onChange={(e) => setLeadershipGroupData({ ...leadershipGroupData, order: e.target.value })}
                                required
                            />
                        </div>

                        <div className="flex max-xm:flex-col gap-4 !mt-4">
                            <button
                                type="button"
                                className="px-6 py-2 min-w-[150px] rounded text-black text-sm font-semibold border-none outline-none bg-gray-200 hover:bg-gray-300 active:bg-gray-200"
                                onClick={closeModal}
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                className="px-6 py-2 min-w-[150px] rounded text-white text-sm font-semibold border-none outline-none bg-secondary hover:bg-custom-blue"
                            >
                                {isProcessing ?
                                    <>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18px" fill="#fff" className="mr-2 inline animate-spin"
                                            viewBox="0 0 26.349 26.35">
                                            <circle cx="13.792" cy="3.082" r="3.082" data-original="#000000" />
                                            <circle cx="13.792" cy="24.501" r="1.849" data-original="#000000" />
                                            <circle cx="6.219" cy="6.218" r="2.774" data-original="#000000" />
                                            <circle cx="21.365" cy="21.363" r="1.541" data-original="#000000" />
                                            <circle cx="3.082" cy="13.792" r="2.465" data-original="#000000" />
                                            <circle cx="24.501" cy="13.791" r="1.232" data-original="#000000" />
                                            <path
                                                d="M4.694 19.84a2.155 2.155 0 0 0 0 3.05 2.155 2.155 0 0 0 3.05 0 2.155 2.155 0 0 0 0-3.05 2.146 2.146 0 0 0-3.05 0z"
                                                data-original="#000000" />
                                            <circle cx="21.364" cy="6.218" r=".924" data-original="#000000" />
                                        </svg>
                                        Processing...
                                    </>
                                    :
                                    "Save"
                                }
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default AddLeadershipGroup